<template>
  <section
    v-if="!drilldownState || (drilldownState && !drilldownState.isActive)"
    class="grid grid--compact grid--gutter-bottom"
  >
    <div
      v-for="(item, index) in fns"
      :key="index"
      class="one-whole lap--one-third desk--one-third text-center"
    >
      <ak-box
        class="flex flex--column relative is-selectable"
        size="small"
        rounded
        bordered
        :class="{
          'u-pointer-events-none translucent curso': !enabled(item.feature),
        }"
        @click.prevent="item.fn()"
      >
        <ak-box
          class="mt-tiny mr-tiny absolute absolute--top absolute--right palm--hidden"
          rounded
          bordered
          shortcut
        >
          <ak-tooltip placement="left" has-arrow="false">
            <template #trigger>
              {{ item.key }}
            </template>
            Keyboard Shortcut
          </ak-tooltip>
        </ak-box>
        <ak-icon size="large" color="primary" :type="getItemIcon(item)" />
        <strong class="color-grey mt-tiny">{{ item.label() }}</strong>
      </ak-box>
    </div>
  </section>
  <ak-notification
    v-if="drilldownState && drilldownState.isActive"
    type="warning"
    closable="false"
  >
    You must be in an account to use quick actions!
  </ak-notification>
</template>

<script>
import { defineComponent } from 'vue'
import { drilldownStateObj } from '@akerolabs/akero-vue/src/store'

export default defineComponent({
  name: 'AkQuickActions',
  components: {},
  props: {
    fns: {
      type: Array,
      default: () => [],
    },
    enabled: {
      type: Function,
      default: () => {},
    },
  },
  setup() {
    const drilldownState = drilldownStateObj()

    /**
     * @param {Object}
     * @return {String}
     * @description Gets angular item icon and strips
     * 'icon-' for empty state
     */
    const getItemIcon = (item) => {
      return item.icon.split('icon-').pop()
    }

    return {
      getItemIcon,
      drilldownState,
    }
  },
})
</script>
